export default "__VITE_ASSET__pzK_vdYO__"